// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"20":"889db586","321":"46d715fb","734":"0c04e9cb","978":"0d629ccc"}[chunkId] + ".js";
};